import sfLoading from '../assets/icons/sf_loading.gif'
import sidewayLogo from '../assets/SidewayLogoOnly.png'

interface LoaderProps {
  message?: string
}

function isCorporateTheme(): boolean {
  return document.documentElement.classList.contains('theme-corporate')
}

export function Loader({ message }: LoaderProps) {
  const corporate = isCorporateTheme()

  return (
    <div className={`fixed inset-0 flex flex-col items-center justify-center z-50 ${corporate ? 'bg-white' : 'bg-cosmic-void'}`}>
      <div className="flex flex-col items-center gap-6">
        {corporate ? (
          <img
            data-testid="loader-animation"
            src={sidewayLogo}
            alt="Star Forge Loading"
            className="w-24 h-24 object-contain animate-pulse"
          />
        ) : (
          <img
            data-testid="loader-animation"
            src={sfLoading}
            alt="Star Forge Loading"
            className="w-48 h-48 object-contain"
          />
        )}

        <div className="flex flex-col items-center gap-2">
          <h1 className={`text-3xl font-bold ${corporate ? 'text-slate-800' : 'bg-gradient-to-r from-cosmic-star via-cosmic-nebula to-cosmic-plasma bg-clip-text text-transparent'}`}>
            Star Forge
          </h1>
          {message && (
            <p className={`text-sm animate-pulse ${corporate ? 'text-slate-500' : 'text-gray-400'}`}>{message}</p>
          )}
        </div>
      </div>
    </div>
  )
}
